export default __webpack_public_path__ + "static/media/ellipsis.267b45a1.svg";